<template>
    <div>
        <!--PAGE HEADER-->
            <app-page-header :areaTitle="departmentName" :menuItem="menuItem" />
        
        <!--REGISTRATION FORM-->
            <div class="row justify-content-center mb-5">
                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-6">                    
                    <div class="card mt-2">
                        <div class="card-header lead">Registration form</div>
                            <div class="card-body">
                                <div class="card-text">
                                    <input @input="$v.username.$touch()" class="form-control mb-2" placeholder="Enter username" type="text" v-model="username">
                                            <small class="text-danger" v-if="!$v.username.required">* The username is required</small>

                                    <input @input="$v.useremail.$touch()" class="form-control mb-2" placeholder="Enter email" type="email" v-model="useremail">
                                            <small class="text-danger" v-if="!$v.useremail.email">* Please provide a valid email</small>
                                            <small class="text-danger" v-if="!$v.useremail.required">* The email address is required</small> 

                                    <input @input="$v.userpassword.$touch()" class="form-control mb-2" placeholder="Enter password" type="password" v-model="userpassword">
                                            <small class="text-danger" v-if="!$v.userpassword.required">* Password is required</small>
                                            <small class="text-danger" v-if="!$v.userpassword.minLength">* Password minimum length: 6</small>

                                    <input @input="$v.userpassword2.$touch()" class="form-control mb-2" placeholder="Re-enter password" type="password" v-model="userpassword2">
                                            <small class="text-danger" v-if="!$v.userpassword2.required">* Password is required!</small>
                                            <small class="text-danger" v-if="!$v.userpassword2.sameAsPassword">* Password not match!</small>                                            
                                        <hr>
                                    <button class="form-control btn btn-outline-secondary pt-4 pb-5" @click="register">Register</button>                        
                                </div>
                            </div>
                    </div>
                </div>
            </div>

        <!--CONFIRMATION MESSAGES-->
            <app-confirmation @showDialogue="closeDialogue" :successMessage="successMessage" :errorMessage="errorMessage" v-if="showingMessageModal" />
    </div>
</template>

<script>
    import axios from 'axios'
    import pageHeader from '@/components/Helpers/PageHeader.vue'
    import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
    import conDialog from '@/components/Helpers/ConfirmationDialogue.vue'

    export default {
            components: {
                    'app-confirmation' : conDialog,
                    'app-page-header' : pageHeader
                },
            data() {
                return {
                        apiURL: process.env.APP_API,
                        departmentName: "Users Registration Area",
                        menuItem: 'New Users Registration',

                        showingMessageModal: false,
                        errorMessage: '',
                        successMessage: '',
                        username: '',
                        userpassword: '',
                        userpassword2: '',                
                        useremail: ''
                    }
                },            
            validations: {
                    username: {
                        required
                    },                
                    useremail: {
                        required,
                        email
                    },
                    userpassword: {
                        required,
                        minLength: minLength(6)
                    },
                    userpassword2: {
                        required,
                        sameAsPassword: sameAs('userpassword')
                    }
                },
            methods: {
                    closeDialogue(status){
                            this.showingMessageModal = status
                        },
                    register(){
                        var formData = new FormData()

                        formData.append('username', this.username)
                        formData.append('useremail', this.useremail)                
                        formData.append('userpassword', this.userpassword)

                            // for(var item of formData){
                            //      console.log('На отправку!', item)
                            //     }  

                           axios.post(this.apiURL + '?action=register', formData)
                                .then((res) => {
                                    if(res.data.error){
                                        // console.log(res.data)                                
                                        this.errorMessage = res.data.message
                                        this.showingMessageModal = true

                                    } else {
                                        // console.log(res.data)  
                                        this.successMessage = res.data.message
                                        this.showingMessageModal = true
                                            setTimeout(()=> {
                                                this.showingMessageModal = false
                                        }, 2000)                   
                                    }
                                })
                    }
                }
        }
</script>

<style>
    /* MODAL MESSAGE */    
    .modalMessageContent {
        min-height: 100px;
        padding: 10px;
    }
    .modalMessageContainer {
        width: 500px;
        background: #ffffff;
        margin: auto;
        margin-top: 150px;
        border-radius: 8px;
    }
    .modalMessageHeading {
        padding: 9px;
        color: #ffffff;
    }
    .modMessageBackground {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom:0;
        background: rgba(0,0,0,0.4); z-index:99;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/Register.vue